"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumOrderSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const combine_labels_1 = require("../../utils/combine-labels");
const meta_data_1 = require("../base/meta-data");
exports.SourgumOrderSchema = {
    name: 'sourgum-order',
    alias: 'Sourgum Order',
    shortName: 'Order',
    applications: ['aap', 'customer-portal'],
    disabled: false,
    mirrorSync: [
        {
            index: 'sourgum-order-production-analytics',
            environments: ['production'],
            transformer: (order) => {
                var _a, _b;
                const doc = order;
                (_b = (_a = doc === null || doc === void 0 ? void 0 : doc.serviceLocation) === null || _a === void 0 ? void 0 : _a.coordinates) === null || _b === void 0 ? true : delete _b.lng;
                return doc;
            },
        },
    ],
    returnType: {
        aap: transport_types_1.Order.AllianceOrderTransport,
        'customer-portal': transport_types_1.Order.AllianceOrderCustomerTransport,
    },
    searchableAttributes: [
        {
            field: 'serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'vendorName',
            alias: 'Vendor Name',
            shortName: 'Vendor',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'dumpTicketNumber',
            alias: 'Dump Ticket Number',
            shortName: 'Dump Ticket Number',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'orderNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
            boost: 1.5,
        },
        {
            field: 'poNumber',
            alias: 'PO Number',
            shortName: 'PO Number',
            searchableByDefault: true,
        },
        {
            field: 'accountManagerName',
            alias: 'Account Manager Name',
            shortName: 'am',
            searchableByDefault: false,
        },
        {
            field: 'accountRepName',
            alias: 'Account Executive Name',
            shortName: 'ae',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            field: 'expectedDeliveryDate',
            alias: 'Expected Delivery Date',
            shortName: 'Delivery Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
            needsDeterministicSorting: true,
        },
        {
            field: 'expectedPickupDate',
            alias: 'Expected Pickup Date',
            shortName: 'Pickup Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
            needsDeterministicSorting: true,
        },
        {
            field: 'expirationDate',
            alias: 'Expiration Date',
            shortName: 'Expiration Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
            needsDeterministicSorting: true,
        },
        {
            field: 'status',
            alias: 'Order Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: {
                aap: (0, combine_labels_1.combineLabels)(transport_types_1.Order.OrderStatuses.map((key) => ({
                    value: String(key),
                    label: transport_types_1.Order.SourgumOrderStatusLabels[key],
                }))),
                'customer-portal': (0, combine_labels_1.combineLabels)(transport_types_1.Order.OrderStatuses.map((key) => ({
                    value: String(key),
                    label: transport_types_1.Order.CustomerPortalOrderStatusLabels[key],
                }))),
            },
            allowsMultipleValues: true,
        },
        {
            field: 'material',
            alias: 'Material',
            shortName: 'Material',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Materials.map((key) => ({
                value: key,
                label: transport_types_1.MaterialLabels[key],
            })),
        },
        {
            field: 'expectedSize.size',
            alias: 'Expected Size',
            shortName: 'Size',
            type: 'NUMBER',
            format: 'INTEGER',
            allowedOperators: 'ALL',
        },
        {
            field: 'needsAttention',
            alias: 'Needs Attention',
            shortName: 'Needs Attention',
            type: 'BOOLEAN',
            allowedOperators: ['IS_EQUAL_TO'],
            disabledOn: ['customer-portal'],
        },
        {
            field: 'haulerConfirmedDelivery',
            alias: 'Hauler Confirmed Delivery',
            shortName: 'Hauler Confirmed Delivery',
            type: 'BOOLEAN',
            allowedOperators: ['IS_EQUAL_TO'],
            disabledOn: ['customer-portal'],
        },
        {
            field: 'haulerConfirmedPickup',
            alias: 'Hauler Confirmed Pickup',
            shortName: 'Hauler Confirmed Pickup',
            type: 'BOOLEAN',
            allowedOperators: ['IS_EQUAL_TO'],
            disabledOn: ['customer-portal'],
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=sourgum-order.js.map